import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useClickAway } from "@uidotdev/usehooks";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { getProfileSearchURL } from "util/navigation.util";
import { useAppSelector } from "store/hooks";
import { getColorTheme } from "store/slices/userSessionSlice";
import { IHncUserSearchResult } from "types/user.interface";
import SearchIcon from "components/Elements/Icons/SearchIcon";
import NavBarSearchResultCard from "../NavBarSearchResultCard/NavBarSearchResultCard";

const ResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  color: #575757;
  position: absolute;
  top: 40px;
  z-index: 99;
  margin-top: 0px;
  border: none;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  gap: 0px;
  width: 520px;
  border: solid thin #e2e2e2;

  .view-all-results-container {
    display: flex;
    align-items: center;
    &:hover {
      cursor: pointer;
      background-color: rgba(182, 181, 181, 0.9);
    }
  }
`;

const SearchSpinnerContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px 12px;
  p {
    text-decoration: none;
    color: #222222;
    font-size: 15px;
    margin: 0;
    line-height: 16px;
  }
  svg {
    color: #222222;
  }
`;

const ViewAllResultsContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px 12px;
  p {
    text-decoration: none;
    color: #222222;
    font-size: 15px;
    margin: 0;
    line-height: 16px;
  }
  svg {
    color: #222222;
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(182, 181, 181, 0.9);
  }
`;
interface INavBarResultsProps {
  isFetching: boolean;
  searchValue: string;
  searchResults: IHncUserSearchResult[];
  clearResults: () => void;
  setShowResults: (b: boolean) => void;
}
export default function NavBarResults(props: INavBarResultsProps) {
  const {
    isFetching,
    searchValue,
    searchResults,
    setShowResults,
    clearResults,
  } = props;

  // get current theme value from store
  const theme = useAppSelector(getColorTheme);

  const ref: React.MutableRefObject<HTMLDivElement> = useClickAway(() => {
    setShowResults(false);
  });

  if (isFetching) {
    return (
      <ResultsContainer ref={ref}>
        <SearchSpinnerContainer>
          <FontAwesomeIcon icon={faSpinner} spin />
          <p>Searching for users.</p>
        </SearchSpinnerContainer>
      </ResultsContainer>
    );
  }

  return (
    <ResultsContainer ref={ref}>
      {/* Render the top 5 results with nav link to the user profile */}

      {searchResults.map((profile) => (
        <NavLink
          end
          key={profile.username}
          className="search-result-container"
          to={`/user/${profile._id}`}
          onClick={clearResults}
          data-theme={theme}
        >
          <NavBarSearchResultCard profile={profile} />
        </NavLink>
      ))}

      {/* Give the user the option to search for all profiles with the search value name */}

      <NavLink
        className="view-all-results-container"
        to={getProfileSearchURL(searchValue)}
        onClick={clearResults}
        end
      >
        <ViewAllResultsContainer>
          <SearchIcon size={16} color="#222222" />
          <p>Search for {`'${searchValue}'`}</p>
        </ViewAllResultsContainer>
      </NavLink>
    </ResultsContainer>
  );
}
